import React, { useState } from "react";
import { createPortal } from "react-dom";
import GiftCard from "./GiftCard";

// Print choices for the card:
//  - Envelope Sized (Half Page): front and back, each 7.7 x 5 in (half a Letter
//    page, a fit for an A9 envelope), one above the other on a portrait page
//    with a light cut line between them;
//  - Full Page (2 pages): the front on page 1 and the back on page 2, each a
//    full Letter landscape page.
// The sheet is rendered straight into <body> (hidden on screen) so printing
// shows exactly it and nothing else, and pages break normally.
export default function GiftCardPrint({ card }) {
  const [size, setSize] = useState("half");
  const [plain, setPlain] = useState(false);

  const half = size === "half";
  const cardProps = { ...card, plain, size: half ? "half" : "full" };

  const sheet = (
    <div className={`gift-print-sheet gift-print-sheet-${size}`} aria-hidden="true">
      <style>{`@page { size: letter ${half ? "portrait" : "landscape"}; margin: 0.25in; }`}</style>
      {half ? (
        <>
          <GiftCard {...cardProps} side="front" />
          <div className="vs-cut" />
          <GiftCard {...cardProps} side="back" />
        </>
      ) : (
        <>
          <div className="vs-print-page">
            <GiftCard {...cardProps} side="front" />
          </div>
          <div className="vs-print-page">
            <GiftCard {...cardProps} side="back" />
          </div>
        </>
      )}
    </div>
  );

  return (
    <div className="vs-print">
      <div className="vs-print-options no-print">
        <fieldset className="vs-print-sizes">
          <legend className="vsr-label">Print size</legend>
          <label>
            <input type="radio" name="vs-print-size" checked={half} onChange={() => setSize("half")} /> Envelope Sized (Half Page) — front
            and back on one page; cut along the dotted line
          </label>
          <label>
            <input type="radio" name="vs-print-size" checked={!half} onChange={() => setSize("full")} /> Full Page (2 pages) — the front on
            page 1, the back on page 2
          </label>
        </fieldset>
        <label className="vs-print-plain">
          <input type="checkbox" checked={plain} onChange={(e) => setPlain(e.target.checked)} /> Print with white background (uses less
          ink)
        </label>
        <p className="vsr-hint">
          In the print window choose <b>Letter</b>, {half ? "portrait" : "landscape"}, and scale <b>100% / Actual size</b>. Colors can look
          different on every printer, so print one test copy first.
        </p>
        <button type="button" className="vsr-btn vsr-btn-outline" onClick={() => window.print()}>
          Print / Save as PDF
        </button>
      </div>
      {createPortal(sheet, document.body)}
    </div>
  );
}
